export const SERVICES = [
  {
    slug: "/lunar-signature-facial-orlando",
    name: "Lunar Signature Facial",
    shortName: "Lunar Signature Facial",
    schemaName: "Lunar Signature Facial",
    price: "$130.00",
    duration: "Duration: 60 minutes",
    durationShort: "60 minutes",
    description:
      "The Lunar Signature Facial is a customized treatment designed to refresh and nourish your skin. This relaxing facial combines deep cleansing, enzyme exfoliation, and a personalized mask with a soothing face, neck, and shoulder massage. Finished with targeted skincare products, moisturizer, and SPF, it leaves your complexion feeling soft, hydrated, and radiant.",
    idealFor:
      "Ideal for anyone wanting a customized, deeply relaxing facial that leaves skin soft, hydrated, and radiant.",
    bookLabel: "Book Lunar Signature Facial",
    bookUrl:
      "https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services/RPGMBZQGGNMWLWLW3S4Z7CL3",
    image: "/images/lunar-signature-facial-orlando.jpg",
    imageAlt:
      "Alena, wearing a light blue Lunar Ambitions uniform and black gloves, brushing a customized treatment mask onto a reclining client's face during a Lunar Signature Facial in Orlando FL.",
    seoTitle: "Lunar Signature Facial in Orlando, FL | Lunar Ambitions",
    seoDescription:
      "Customized signature facial in Orlando, FL with deep cleansing, enzyme exfoliation, a personalized mask, and a relaxing face, neck, and shoulder massage. Serving Winter Park, Dr. Phillips, Windermere, Kissimmee, and Orlando.",
  },
  {
    slug: "/smooth-radiance-dermaplaning-facial-orlando",
    name: "Smooth Radiance Dermaplaning Facial",
    shortName: "Smooth Radiance Dermaplaning",
    schemaName: "Smooth Radiance Dermaplaning Facial",
    price: "$150.00",
    duration: "Duration: 90 minutes",
    durationShort: "90 minutes",
    description:
      "The Smooth Radiance Dermaplaning Facial combines professional dermaplaning with nourishing skincare to reveal a smoother, brighter complexion. This treatment gently removes dead skin cells and peach fuzz, followed by customized products to replenish moisture and enhance your skin's natural radiance, leaving it soft, silky, and refreshed.",
    idealFor:
      "Ideal before events or as regular maintenance for anyone seeking silky-smooth, peach-fuzz-free skin with a luminous finish.",
    bookLabel: "Book Smooth Radiance Dermaplaning",
    bookUrl:
      "https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services/IQNIDRSDUITHTR3QWAP6BQ3L",
    image: "/images/smooth-radiance-dermaplaning-facial-orlando.jpg",
    imageAlt:
      "Gloved esthetician performing a Smooth Radiance Dermaplaning Facial surrounded by white roses and candles at Lunar Ambitions in Orlando FL.",
    seoTitle:
      "Smooth Radiance Dermaplaning Facial in Orlando, FL | Lunar Ambitions",
    seoDescription:
      "90-minute dermaplaning facial in Orlando, FL that removes peach fuzz and dead skin cells, then replenishes moisture for a smooth, silky, radiant complexion. Serving Winter Park, Dr. Phillips, Windermere, and Orlando.",
  },
  {
    slug: "/nano-needling-hydration-facial-orlando",
    name: "Nano Needling Hydration Facial",
    shortName: "Nano Needling Hydration",
    schemaName: "Nano Needling Hydration Facial",
    price: "$210.00",
    duration: "Duration: 75 minutes",
    durationShort: "75 minutes",
    description:
      "The Nano Needling Hydration Facial uses a specialized nano infusion technique to enhance the absorption of hydrating serums and nourishing skincare ingredients. This gentle treatment helps improve skin hydration, softness, and radiance, leaving your complexion looking fresh, plump, and luminous.",
    idealFor:
      "Ideal for anyone seeking deep hydration and a fresh, plump, luminous glow, including those with sensitive skin.",
    bookLabel: "Book Nano Needling Hydration Facial",
    bookUrl:
      "https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services/24LW3NOCPKIHZRZOVRAK4LXT",
    image: "/images/nano-needling-hydration-facial-orlando.jpg",
    imageAlt:
      "Gloved esthetician gliding a nano needling pen across a client's forehead during a Nano Needling Hydration Facial at Lunar Ambitions in Orlando FL.",
    seoTitle: "Nano Needling Hydration Facial in Orlando, FL | Lunar Ambitions",
    seoDescription:
      "Nano needling hydration facial in Orlando, FL using nano infusion to drive hydrating serums deeper for softer, plumper, more luminous skin. Gentle, with no downtime. Serving Winter Park, Dr. Phillips, Windermere, and Orlando.",
  },
  {
    slug: "/professional-chemical-peel-orlando",
    name: "Professional Chemical Peel",
    shortName: "Professional Chemical Peel",
    schemaName: "Professional Chemical Peel",
    price: "$140.00",
    duration: "Duration: 60 minutes",
    durationShort: "60 minutes",
    description:
      "The Professional Chemical Peel is designed to improve skin texture, refine the appearance of pores, and promote a brighter, more even-looking complexion. This targeted exfoliating treatment helps remove dull surface cells and encourages skin renewal, leaving your skin smoother, refreshed, and radiant.",
    idealFor:
      "Ideal for those targeting uneven skin texture, dullness, visible pores, or an uneven-looking complexion.",
    bookLabel: "Book Professional Chemical Peel",
    bookUrl:
      "https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services/7RT5TL3CCQCU7NLGGJFI5PHP",
    image: "/images/professional-chemical-peel-orlando.jpg",
    imageAlt:
      "Close-up profile of a woman with bright, even-toned skin after a professional chemical peel at Lunar Ambitions in Orlando FL.",
    seoTitle: "Professional Chemical Peel in Orlando, FL | Lunar Ambitions",
    seoDescription:
      "Professional chemical peel in Orlando, FL that exfoliates dull surface cells to smooth texture, refine pores, and brighten an uneven complexion. Serving Winter Park, Kissimmee, Dr. Phillips, Windermere, and Orlando.",
  },
  {
    slug: "/express-refresh-facial-orlando",
    name: "Express Refresh Facial",
    shortName: "Express Refresh Facial",
    schemaName: "Express Refresh Facial",
    price: "$65.00",
    duration: "Duration: 30 minutes",
    durationShort: "30 minutes",
    description:
      "The Express Refresh Facial is a quick, revitalizing treatment designed to refresh your complexion in just 30 minutes. Featuring gentle cleansing, light exfoliation, and nourishing skincare products, this facial helps restore hydration and revive dull, tired-looking skin, leaving you with a fresh, healthy-looking glow.",
    idealFor:
      "Ideal for busy schedules, first-time clients, or anyone wanting a fast hydration boost before an event.",
    bookLabel: "Book Express Refresh Facial",
    bookUrl:
      "https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services/3IDXKGULNACJDPNFM7QTB6E2",
    image: "/images/express-refresh-facial-orlando.jpg",
    imageAlt:
      "Woman with smooth, dewy skin tilting her face upward in sunlight after an Express Refresh Facial at Lunar Ambitions in Orlando FL.",
    seoTitle: "Express Refresh Facial in Orlando, FL | Lunar Ambitions",
    seoDescription:
      "30-minute express facial in Orlando, FL with gentle cleansing, light exfoliation, and hydration to revive dull, tired skin. Perfect for busy schedules. Serving Winter Park, Dr. Phillips, Windermere, and Orlando.",
  },
  {
    slug: "/mens-express-facial-orlando",
    name: "Men's Express Facial",
    shortName: "Men's Express Facial",
    schemaName: "Men's Express Facial",
    price: "$75.00",
    duration: "Duration: 30 minutes",
    durationShort: "30 minutes",
    description:
      "The Men's Express Facial is a refreshing, results-focused treatment designed for busy schedules. This targeted facial includes deep cleansing, gentle exfoliation, and customized skincare to help remove excess oil, clear congested pores, and leave your skin feeling clean, balanced, and revitalized in just 30 minutes.",
    idealFor:
      "Ideal for those with a busy schedule or anyone looking for an approachable introduction to professional skin care.",
    bookLabel: "Book Men's Express Facial",
    bookUrl:
      "https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services/X6BDG35XUQZBFSBUFBFBNS23",
    image: "/images/mens-express-facial-orlando.jpg",
    imageAlt:
      "Gloved esthetician in a light blue uniform applying a cleansing treatment to a male client during a men's express facial at Lunar Ambitions in Orlando FL.",
    seoTitle: "Men's Express Facial in Orlando, FL | Lunar Ambitions",
    seoDescription:
      "30-minute men's facial in Orlando, FL that clears pores, removes excess oil, and refreshes skin with zero downtime. Great intro to professional men's skin care. Serving Winter Park, Dr. Phillips, Windermere, and Orlando.",
  },
];
